{
  "int_ops": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "exp_neg": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "evaluate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "distribute": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "combine_like": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "exp_product": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "eq_solve": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "poly_degree": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "std_form": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "poly_add": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "poly_sub": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "mono_poly": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "binom_tiles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "binom_box": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "binom_dist": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "special_sq": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "special_diff": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "poly_mult": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_expr": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_shaded": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_solve": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_order_ops": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_rational_ops": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_eq_two_step": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_eq_fractions": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_eq_special": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_literal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_abs_eq": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_ineq_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_ineq_solve": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_ineq_compound": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_abs_ineq": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_word_eq": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u1_word_ineq": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u2_exp_quotient": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u2_exp_power": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u2_exp_zero_neg": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u2_exp_combined": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u2_sci_notation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u2_classify_poly": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u3_relation_function": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u3_domain_range": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u3_func_eval": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u3_func_input": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u3_func_table": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u3_arith_seq": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u3_abs_func": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u3_transform": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u3_key_features": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u4_slope_points": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u4_slope_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u4_slope_intercept": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u4_point_slope": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u4_two_points": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u4_standard_form": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u4_intercepts": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u4_parallel_perp": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u4_linear_model": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u4_graph_match": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u5_graph_solution": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u5_substitution": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u5_elimination": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u5_elim_multiply": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u5_classify": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u5_word": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u5_linear_ineq": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u5_ineq_system": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u6_simplify": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u6_multiply": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u6_add_sub": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u6_rationalize": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u6_binomial": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u6_rational_exp": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u6_exp_radical_convert": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u6_pythag": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u7_gcf": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u7_trinomial_a1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u7_grouping": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u7_trinomial_a": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u7_diff_squares": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u7_perfect_square": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u7_complete": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u7_identify": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u8_key_features": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u8_zero_product": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u8_solve_factoring": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u8_square_roots": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u8_complete_square": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u8_quad_formula": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u8_discriminant": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u8_projectile": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u8_graph_match": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u8_vertex_standard": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u9_exp_eval": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u9_growth_decay": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u9_exp_model": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u9_compound_interest": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u9_exp_table": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u9_solve_bases": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u9_geo_seq": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "u9_exp_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_center": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_spread": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_distribution": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_plots": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_two_way": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_scatter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_residual": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_correlation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_fit": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_standard_deviation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_residual_pattern": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_table_association": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "s_table_totals": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_piecewise": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_piecewise_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_average_rate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_compare_functions": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_context_domain": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_recursive": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_recursive_rule": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_growth_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_growth_eventual": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_inverse": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_function_arithmetic": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_units": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_units_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_variation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_radical_equation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_rational_equation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_rational_simplify": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_intersections": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_profit": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_equation_reason": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_precision": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_graph_qualitative": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_parameter_equation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c_number_closure": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_irrational": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_repeating": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_root_estimate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_cube_root": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_translate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_reflect": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_rotate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_dilate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_composition": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_similarity": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_similar_lengths": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_triangle_angles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_parallel_angles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_angle_reason": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_pythagorean": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_pythagorean_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_converse": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_distance": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_space_diagonal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_cylinder_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_cone_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_sphere_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g8_scatter_patterns": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_ratio_read": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_ratio_equivalent": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_ratio_total": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_unit_rate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_fraction_rate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_rate_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_proportion_table": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_proportion_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_ratio_coordinates": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_percent_convert": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_percent_part": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_percent_rate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_percent_whole": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_percent_change": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_percent_new": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_percent_reverse": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_percent_successive": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_percent_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_opposite": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_absolute": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_number_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_reciprocal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_zero_rules": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_divisible": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_prime": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_prime_factors": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_gcf": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_lcm": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_decimal_type": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_rational_power": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_negative_power": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_science_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_science_add": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_science_product": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_root_evaluate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_words": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_structure": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_rational_eval": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_fraction_terms": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_linear_factor": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_one_step_add": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_one_step_multiply": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_proportion_equation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_point_check": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_axis_lines": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_segment_add": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_midpoint": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_angle_type": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_complement": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_supplement": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_angle_bisector": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_vertical_angles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_triangle_type": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_triangle_inequality": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_polygon_angles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_quadrilaterals": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_area_rectangle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_area_parallelogram": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_area_triangle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_area_trapezoid": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_perimeter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_composite_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_circle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_box_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_scale_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_mode": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_mean_frequency": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_mad": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_mean_remove": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_distribution_shape": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_simple_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_probability_complement": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_independent_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_experimental_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_geometry_objects": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_angle_measure": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_isosceles_angles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_perpendicular_bisector": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pa_linear_gcf": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_place": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_expanded": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_regroup": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_round10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_round100": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_add": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_subtract": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_subtract_zero": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_missing_addend": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_estimate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_groups": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_arrays": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_facts2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_facts3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_facts4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_facts5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_facts6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_facts7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_facts8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_facts9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_zero_one": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_commute": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_split": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_associate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_tens_product": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_share": {
    "policy": "word",
    "roles": [
      "countable",
      "person"
    ],
    "slots": {
      "items": {
        "role": "countable",
        "generic": "sticker",
        "tags": [
          "portable"
        ]
      },
      "people": {
        "role": "person",
        "generic": "child"
      }
    }
  },
  "g3_group_divide": {
    "policy": "word",
    "roles": [
      "countable",
      "container"
    ],
    "slots": {
      "items": {
        "role": "countable",
        "generic": "pencil",
        "tags": [
          "portable"
        ]
      },
      "containers": {
        "role": "container",
        "generic": "bag"
      }
    }
  },
  "g3_divide_facts": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_missing_factor": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_mixed_facts": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_two_step": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_patterns": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_even_odd": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_unit_fraction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_fraction_parts": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_fraction_line": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_fraction_over_one": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_fraction_whole": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_equivalent_fraction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_compare_denominator": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_compare_numerator": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_whole_matters": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_time_read": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_elapsed": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_time_later": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_volume_units": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_volume_problem": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_mass_units": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_mass_problem": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_volume_groups": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_mass_change": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_mass_share": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_picture_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_bar_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_graph_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_ruler": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_line_plot": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_line_plot_total": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_unit_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_rectangle_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_area_missing": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_area_split": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_composite_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_perimeter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_polygon_perimeter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_perimeter_missing": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_area_perimeter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_same_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_quadrilateral": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_shape_attributes": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g3_partition_shape": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_place_tens": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_hundreds": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_expanded": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_trade": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_read_words": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_number_words": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_skip5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_skip10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_skip100": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_count1000": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_10more": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_10less": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_100more": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_100less": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_add20": {
    "policy": "bare",
    "roles": [],
    "slots": {}
  },
  "g2_subtract20": {
    "policy": "bare",
    "roles": [],
    "slots": {}
  },
  "g2_doubles": {
    "policy": "bare",
    "roles": [],
    "slots": {}
  },
  "g2_near_doubles": {
    "policy": "bare",
    "roles": [],
    "slots": {}
  },
  "g2_missing20": {
    "policy": "bare",
    "roles": [],
    "slots": {}
  },
  "g2_fact_family": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_add100": {
    "policy": "bare",
    "roles": [],
    "slots": {}
  },
  "g2_subtract100": {
    "policy": "bare",
    "roles": [],
    "slots": {}
  },
  "g2_add_four": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_add1000": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_subtract1000": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_zero_trade": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_unknown_start": {
    "policy": "word",
    "roles": [
      "countable",
      "container"
    ],
    "slots": {
      "items": {
        "role": "countable",
        "generic": "ball",
        "tags": [
          "portable"
        ]
      },
      "container": {
        "role": "container",
        "generic": "box"
      }
    }
  },
  "g2_compare_story": {
    "policy": "word",
    "roles": [
      "countable"
    ],
    "slots": {
      "items": {
        "role": "countable",
        "generic": "ball",
        "tags": [
          "portable"
        ]
      }
    }
  },
  "g2_two_step": {
    "policy": "word",
    "roles": [
      "countable",
      "structure"
    ],
    "slots": {
      "supplies": {
        "role": "countable",
        "generic": "board",
        "tags": [
          "building-material"
        ]
      },
      "structure": {
        "role": "structure",
        "generic": "bridge"
      }
    }
  },
  "g2_even_odd": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_array_sum": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_equal_pairs": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_pattern": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_length_units": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_length_estimate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_number_line": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_ruler": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_length_difference": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_length_join": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_unit_size": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_length_order": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_clock5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_am_pm": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_coin_value": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_count_coins": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_dollar_cents": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_money_change": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_picture_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_bar_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_graph_total": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_graph_difference": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_line_plot": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_shape_sides": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_cube_faces": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_partition": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_equal_shares": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_rectangle_tiles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_compose_shape": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_balance": {
    "policy": "bare",
    "roles": [],
    "slots": {}
  },
  "g2_true_equation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_number_riddle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g2_difference_clue": {
    "policy": "word",
    "roles": [
      "countable"
    ],
    "slots": {
      "items": {
        "role": "countable",
        "generic": "ball",
        "tags": [
          "portable"
        ]
      }
    }
  },
  "g2_missing_path": {
    "policy": "bare",
    "roles": [],
    "slots": {}
  },
  "g1_count120": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_place": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_teen": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_tens": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_digit_value": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_expand": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_compare": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_ten_more": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_ten_less": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_add10": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_subtract10": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_count_on": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_add20": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_subtract20": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_doubles": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_near_doubles": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_commute": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_three_parts": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_add_one_digit": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_add_tens": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_add100": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_subtract_tens": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_make_ten": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_subtract_bridge": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_missing": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_family": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_missing_start": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_missing_change": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_compare_story": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_fewer_story": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_equal": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_balance": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_unknown_equation": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_measure": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_length_order": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_indirect_length": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_unit_rule": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_clock": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_graph_read": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_graph_total": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_graph_difference": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_sort": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_shape_attributes": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_compose": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_compose_circle": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_solid": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_partition": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_share_size": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_compose_solid": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_team_join": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_team_missing": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "g1_team_balance": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_count5": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_count10": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_count20": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_scattered": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_zero": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_numeral": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_next": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_tens": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_count100": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_same_count": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_compare_groups": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_compare_numbers": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_make10": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_parts": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_teen": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_teen_extra": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_add5": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_subtract5": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_add10": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_subtract10": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_join_story": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_leave_story": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_hidden_story": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_length": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_weight": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_attributes": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_sort": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_category_order": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_flat_shape": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_solid": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "k5_flat_solid": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_sides": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_position": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_compose": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k5_pattern": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_small": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_count10": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_scattered": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_quick": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_numeral": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_one_more": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_next": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_same_count": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_compare": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_order": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_join": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_take": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_hidden": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_story": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_sort_shape": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_sort_size": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_pattern_AB": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_pattern_AAB": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_pattern_ABC": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_length": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_measure": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_height": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_weight": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_shape": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_sides": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_position": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "k4_solid": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "k4_compose": {
    "roles": [],
    "slots": {},
    "policy": "pictures"
  },
  "count": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "compare": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "place": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "place1000": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "add10": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "add20": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "add100": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "add1000": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "sub10": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "sub20": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "sub100": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "sub1000": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "skip": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "groups": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "multiply": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "divide": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "halves": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "fraction": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "fractionCompare": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "shapes": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "measure": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "perimeter": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "time": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "money": {
    "policy": "fixed",
    "roles": [],
    "slots": {}
  },
  "g4_digit4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_digit7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_ten_times": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_write_words": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_read_words": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_expanded_term": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_assemble": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_trade_one": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_trade_many": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_trade_zero": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_compare": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_compare_near": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_round_down": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_round_up": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_round_carry": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_add2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_add3_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_add3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_add5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_add7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_add_three": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_sub2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_sub3_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_sub3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_sub5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_sub7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_estimate_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_estimate_subtract": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_estimate_multiply": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_factor_product": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_factor_count": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_factor_pairs": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_prime": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_multiple": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_lcm": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_factor_multiple": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_gcf": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_multiply10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_multiply100": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_multiply1000": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_zeros_pattern": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_rewrite_zeros": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_multiply_zeros": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_repeated_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_repeated_subtract": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_multiply_area2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_multiply_area4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_multiply_place2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_multiply_place4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_multiply_area22": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_multiply_place22": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_estimate_divide": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_division_inverse": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_remainder_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_remainder": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_division_parts": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_quotient_remainder": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_division_context": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_divide_scaled": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_divide_fact": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_divide_places": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_divide_area2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_divide_area3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_divide_area4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_divide_partial2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_divide_partial_remainder": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_divide_partial4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_order_add_multiply": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_order_multiply_divide": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_story_two_step": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_story_four_ops": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_times_compare": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_compare_equation": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_add_times_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_pattern_generate": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_pattern_identify": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_fraction_parts": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_fraction_line": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_unit_words": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_fraction_words": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_fraction_division": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_improper": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_mixed_models": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_mixed_line": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_mixed_division": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_mixed_wholes": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_mixed_remainder": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_mixed_to_improper": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_equivalent_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_equivalent_scale": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_common_denominator": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_simplify_fraction": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_compare_fraction": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_benchmark_one": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_benchmark_half": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_compare_common_models": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_compare_common": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_fraction_add_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_fraction_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_fraction_subtract": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_fraction_add_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_fraction_subtract_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_fraction_decompose_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_fraction_decompose": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_mixed_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_mixed_subtract": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_mixed_subtract_improper": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_mixed_add_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_mixed_subtract_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_fraction_times_unit": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_fraction_times_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_fraction_times": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_fraction_times_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_fraction_times_simplify": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_decimal_place": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_decimal_line": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_decimal_compare": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_fraction_to_decimal": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_mixed_to_decimal": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_decimal_to_fraction": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_decimal_mixed": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_decimal_fraction_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g4_length_units": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_mass_units": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_time_units": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_volume_units": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_metric_length": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_customary_length": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_convert_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_convert_mass": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_convert_time": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_conversion_table": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_ruler_fraction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_money_decimal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_line_plot": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_fraction_line_plot": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_line_plot_difference": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_geometric_objects": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_angle_measure": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_turn_fraction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_protractor": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_special_angles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_angle_classify": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_shape_angles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_angle_sum": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_angle_missing": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_parallel_perpendicular": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_rectangle_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_rectangle_perimeter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_rectangle_missing": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_area_perimeter_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_triangle_classify": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_symmetry": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_identify_point": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g4_draw_angle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_expression_order": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_expression_group": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_expression_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_expression_terms": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_expression_add_compare": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_expression_times_compare": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_negative": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_negative_compare": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_absolute_value": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_group_symbols": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_multiply_places": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_multiply21": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_multiply41": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_multiply61": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_multiply22": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_multiply42": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_multiply33": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_divide21": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_divide31": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_divide41": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_division_fraction": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_division_round": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_division_remainder_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_division_inverse22": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_division_inverse_rem": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_division_partial22": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_divide32": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_divide42": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_power10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_whole_times_power": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_times_power": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_power_definition": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_power_value": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_power_larger": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_power_fraction": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_power_decimal": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_power_compare": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_expression_powers": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_whole_add_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_whole_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_whole_sub_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_whole_sub": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_estimate": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_unlike_add_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_unlike_sub_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_unlike_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_unlike_sub": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_unlike_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_mixed_unlike_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_mixed_unlike_sub": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_mixed_unlike_improper": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_mixed_unlike_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_fraction_unit_product": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_area_product": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_product": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_product_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_fraction_cancel_product": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_mixed_times_whole": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_mixed_times_fraction": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_mixed_product": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_mixed_product_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_fraction_rectangle_model": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_fraction_rectangle_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_fraction_scaling": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_divide_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_whole_divide_unit_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_whole_divide_unit": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_unit_divide_whole_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_unit_divide_whole": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_reciprocal": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_whole_divide_fraction_model_integer": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_whole_divide_fraction_model_fraction": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_whole_divide_fraction": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_divide_whole_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_divide_whole": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_divide_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_fraction_divide_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_fraction_quotient": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_digit": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_places_compare": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_words": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_expanded": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_assemble": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_equivalent": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_compare": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_round_down": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_round_up": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_significant_whole": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_significant_decimal": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_compare_sign": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_estimate": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_add_unequal": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_sub": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_sub_unequal": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_add_benchmark": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_sub_benchmark": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_multiply_places": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_multiply_shift": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_product_estimate": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_times_one": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_times_many": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_product22": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_product23": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_product33": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_divide_places": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_divide_shift": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_quotient_estimate": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_divide_value": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_whole_decimal_quotient": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_whole_quotient_round": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_divide_algorithm": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_divide32": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_decimal_divide45": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_convert_metric_large": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_convert_customary_large": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_convert_volume_large": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_convert_mass_large": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_convert_time_large": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_fractional_plot_operations": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_construct_line_plot": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_fractional_plot_sharing": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_coordinate_plane": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_coordinate_routes": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_coordinate_map": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_pattern_pair": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_pattern_compare": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g5_pattern_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_volume_cubes": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_area_volume_units": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_prism_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_prism_volume_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_composite_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_polygons": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_quadrilaterals": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_rectangle_rhombus_square": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_polygon_perimeter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g5_quadrilateral_hierarchy": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "a2_long_division": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_synthetic_division": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_remainder_theorem": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_factor_theorem": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_factor_cubic": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_poly_zeros": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_multiplicity": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_end_behavior": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_sum_diff_cubes": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_poly_from_zeros": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_rat_simplify": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_rat_domain": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_vertical_asymptote": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_horizontal_asymptote": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_rat_equation": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_log_evaluate": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_log_exp_form": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_log_properties": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_exp_solve_log": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_log_equation": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_compound_interest": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "a2_exp_model": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "a2_natural_log": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_compose": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_inverse": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_transformations": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_even_odd": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_imaginary_unit": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_complex_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_complex_divide": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_nth_root": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_radical_equation": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_arith_series": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_geo_series": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_geo_infinite": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_recursive_terms": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_powers_i": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_complex_mult": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_complex_conjugate": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_complex_plane": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_complex_modulus": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_quad_complex_roots": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_discriminant_types": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_vertex_form_convert": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_quad_from_vertex": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_quad_from_roots": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_quad_from_complex_roots": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_sum_product_roots": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_quad_ineq": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_line_parabola": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_quad_optimize": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_rat_multiply": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_rat_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_complex_fraction": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_radians": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_coterminal": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_unit_circle": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_right_triangle_trig": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_pythagorean_identity": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_sinusoid": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_limit_direct": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_limit_factor": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_limit_infinity": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_one_sided": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_continuity": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_limit_conjugate": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_diff_quotient": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_power_rule": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_deriv_at_point": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_product_rule": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_quotient_rule": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_chain_rule": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_trig_exp_derivs": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_tangent_line": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_higher_derivative": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_implicit": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_related_rates": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c1_critical_points": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_increasing": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_local_extrema": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_concavity": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_optimization": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c1_mvt": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_linear_approx": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_antiderivative": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_riemann": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_definite_integral": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_ftc_derivative": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_u_substitution": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_area_between": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_average_value": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_by_parts": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_partial_fractions": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_improper": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_volume_disk": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_arc_length": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_series_convergence": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_taylor": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_parametric": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_polar_area": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_separable_de": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_euler": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_lhopital": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_radius_convergence": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_alternating_error": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_logistic": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c2_trig_integrals": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g6_divide21": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_divide31": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_divide41": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_division_fraction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_division_round": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_division_remainder_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_divide32": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_divide42": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_division_inverse": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_division_inverse_rem": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_division_estimate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_whole_fraction_model_integer": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_whole_fraction_model_fraction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_fraction_whole_model": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_whole_fraction_quotient": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_fraction_whole_quotient": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_fraction_whole_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_reciprocal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_fraction_quotient_model": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_fraction_quotient": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_fraction_side_length": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_add": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_subtract": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_add_unequal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_subtract_unequal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_times_whole": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_product22": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_product23": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_product33": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_quotient_whole": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_quotient_round": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_quotient_shift": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_division": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_quotient32": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_quotient45": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_quotient_estimate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_decimal_division_estimate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_negative_values": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_absolute_value": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_negative_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_power_definition": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_exponent_evaluate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_power_larger": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_power_fraction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_power_decimal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_power_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_expression_powers": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_area_volume_units": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_prism_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_prism_volume_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_ratio_meaning": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_equivalent_ratios": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_ratio_fraction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_ratio_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_ratio_approximate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_ratio_missing": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_ratio_share": {
    "roles": [
      "countable"
    ],
    "slots": {
      "item": {
        "role": "countable",
        "generic": "counter",
        "tags": [
          "portable"
        ]
      }
    },
    "policy": "word"
  },
  "g6_ratio_table": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_ratio_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_ratio_tape": {
    "roles": [
      "countable"
    ],
    "slots": {
      "item": {
        "role": "countable",
        "generic": "counter",
        "tags": [
          "portable"
        ]
      }
    },
    "policy": "word"
  },
  "g6_unit_rate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_rate_application": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_speed_rate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_percent_model": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_percent_fraction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_percent_decimal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_percent_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_percent_find": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_percent_part": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_percent_whole": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_percent_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_percent_part_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_convert_metric": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_convert_customary": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_convert_length_division": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_convert_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_convert_mass": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_convert_time": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_fraction_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_mixed_whole": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_mixed_fraction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_whole_mixed": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_fraction_mixed": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_mixed_quotient": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_mixed_division_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_gcf": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_lcm": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_gcf_distribute": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_negative_context": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_absolute_context": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_number_families": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_rational_number_line": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_compare_rationals": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_order_rationals": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_coordinate_read": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_coordinate_rational": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_coordinate_reflect": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_coordinate_context": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_opposites": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_absolute_order": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_expression_intro": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_expression_construct": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_evaluate_linear": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_evaluate_expression": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_expression_terms": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_expression_coefficients": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_like_terms": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_expression_gcf": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_combine_terms": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_distribute": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_factor_linear": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_equivalent_expression": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_equation_check": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_equation_add": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_equation_subtract": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_equation_multiply": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_equation_fraction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_equation_divide": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_equation_model": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_equation_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_inequality_check": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_inequality_line": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_inequality_words": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_two_variable_output": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_two_variable_input": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_two_variable_table": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_two_variable_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_rectangle_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_angle_class": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_right_triangle_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_area_triangle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_area_parallelogram": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_composite_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_area_between": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_symmetry": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_solid_names": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_solid_structure": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_surface_net": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_surface_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_prism_fraction_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_prism_fraction_story": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_coordinate_distance": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_coordinate_polygon": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_coordinate_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_statistics_intro": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_mean": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_median": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_mode": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_iqr": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_mad": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_outliers": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_remove_outliers": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_compare_center": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_compare_spread": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_frequency_table": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_dot_plot": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_box_plot": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_histogram": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_dot_plot_center": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_dot_plot_spread": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_dot_plot_quartiles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_distribution_shape": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_statistical_questions": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_sample_size": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_data_context": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g6_center_choice": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_unit_price": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_unit_price_compare": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_unit_price_multistep": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_fraction_rate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_mixed_rate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_fraction_rate_apply": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_mixed_rate_apply": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_proportion_table": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_proportion_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_proportion_description": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_proportion_interpret": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_percent_increase": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_percent_decrease": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_percent_change": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_percent_original_increase": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_percent_original_decrease": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_percent_successive": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_percent_interpret": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_tax_tip": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_markup_discount": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_commerce_multistep": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_simple_interest": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_subtract_cross_zero": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_subtract_from_negative": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_fraction_negative_difference": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_decimal_negative_difference": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_opposite_sign_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_negative_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_negative_subtract": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_additive_inverse": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_absolute_add_model": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_signed_change_story": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_signed_product": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_negative_product": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_signed_quotient": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_negative_fraction_equivalence": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_negative_decimal_quotient": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_reciprocal": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_zero_products": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_fraction_of_fraction": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_product_interpret": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_rational_expression_value": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_rational_product_story": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_rational_four_operations": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_rational_multistep": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_decimal_representation": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_rational_square": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_rational_cube": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_rational_power": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_power_expression": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_linear_evaluate": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_like_terms": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_linear_collect": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_distribute": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_distribute_three": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_negative_distribute": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_linear_expand_combine": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_subtract_group": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_fraction_coefficients": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_linear_gcf": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_numeric_factor": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_linear_factor": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_equation_trial": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_equation_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_equation_multiply": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_equation_two_step": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_equation_fraction": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_equation_decimal": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_equation_both_sides": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_equation_clear_fraction": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_equation_cross": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_coordinate_read": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_coordinate_distance": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_linear_point_check": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_linear_missing_coordinate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_linear_graph": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_system_solution": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_system_substitution": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_inequality_read": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_inequality_compound": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_inequality_verify": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_inequality_one_step": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_inequality_two_step": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_inequality_negative": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_inequality_number_line": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_linear_context": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_equation_model": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_inequality_context": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_inequality_model_one": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_inequality_model_two": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_rational_evaluate": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_rational_equivalent": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_rational_simplify": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_rational_cancel": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_rational_equation": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "g7_lines_relationship": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_segment_length": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_segment_congruent": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_segment_midpoint": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_collinear_points": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_segment_addition": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_perpendicular_bisector": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_angle_congruent": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_angle_vertical": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_angle_complement": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_angle_supplement": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_angle_bisector": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_angle_equation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_polygon_coordinates": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_triangle_angle_sum": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_triangle_classify": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_triangle_height": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_quadrilateral_classify": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_rectangle_square_properties": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_trapezoid_properties": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_polygon_angle_sum": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_polygon_congruence": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_polygon_perimeter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_rectangle_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_parallelogram_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_triangle_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_trapezoid_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_composite_area_perimeter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_region_between": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_scale_meaning": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_scale_length": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_scale_area_perimeter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_circle_parts": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_circle_circumference": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_circle_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_circle_area_circumference": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_circle_composite": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_circle_parts_area_perimeter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_cube_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_cube_surface": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_prism_surface": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_triangular_prism_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_triangular_prism_surface": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_combined_prism_surface": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_solid_cross_sections": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_sample_representative": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_sample_estimate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_sample_bias": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_survey_interpret": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_sample_margin": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_joint_frequency": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_cumulative_frequency": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_frequency_mean": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_frequency_median": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_frequency_mode": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_histogram_center": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_histogram_mean": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_compare_means": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_compare_medians": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_compare_modes": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_compare_quartiles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_compare_visual_spread": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_compare_spread": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_compare_overlap": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_experimental_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_experimental_prediction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_sample_space": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_event_likelihood": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_simple_event": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_probability_prediction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_probability_model": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_compound_space": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_compound_experiment": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_compound_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_compound_simulation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_construct_sss": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_construct_angles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "g7_construct_scale": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "a2_inverse_nonlinear": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_log_graph": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_sinusoid_graph": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_z_score": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_empirical_rule": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_prob_addition": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_confidence_interval": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_study_design": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "geo_angle_postulates": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_angle_theorems": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_alternate_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_alternate_converse": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_consecutive_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_consecutive_converse": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_perpendicular_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_perpendicular_converse": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_translate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_rotate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_rotation_rule": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_reflect_axes": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_reflect_line": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_dilate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_dilate_center": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_stretch": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_stretch_composition": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_transformation_composition": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_reflection_symmetry": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_rotation_symmetry": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_asa": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_aas": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_sas": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_sss": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_hl": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_congruence_choice": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_rigid_congruence": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_congruence_properties": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cpctc": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_polygon_similarity": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_similar_correspondence": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_similar_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_area_to_scale": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_similarity_motion": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_aa_similarity": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_sss_similarity": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_sas_similarity": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_similarity_choice": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_similarity_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_midsegment": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_midsegment_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_triangle_proportionality": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_parts": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_regions": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circumference": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_central_arc": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_arc_degrees": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_sector_degrees": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_sector_unknown": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_composite": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_in_square": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_square_in_circle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_inscribed_angle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_inscribed_angle_chain": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_thales": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_inscribed_right_angles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_inscribed_right_lengths": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cyclic_quadrilateral": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_radius_tangent": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_two_tangents": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_secant_angles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_tangent_secant_angles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_tangent_chord": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_dilation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_similarity_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_degrees_radians": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_arc_radians": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_sector_radians": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_radians": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_parallel_slopes": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_parallel_equation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_perpendicular_slopes": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_perpendicular_equation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_midpoint": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_partition": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_distance": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_point_line_distance": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_coordinate_perimeter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_coordinate_rectangle_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_coordinate_polygon_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_locus": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_origin": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_equation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_complete_square": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_intercepts": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_line_intersections": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circle_tangent_equation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_diameter_bisector": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_chord_bisector": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_chord_coordinate": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_coordinate_thales": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_exterior_angle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_pythagorean": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_right_isosceles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_right_306090": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_area_45": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_area_30": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_equilateral_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_triangle_angle_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_isosceles_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_centroid": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_centroid_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_square_diagonal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_parallelogram_parts": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_parallelogram_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_rectangle_criteria": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_sides": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_ratios": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_pythagorean": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_lengths": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_angles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_model": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_reciprocals": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_similar": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_complements": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_special": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_trig_two_triangles": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_solid_names": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_solid_features": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_solid_nets": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_net_surface_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_distance_3d": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_euler": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_platonic": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_similar_solids": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cube_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cube_surface": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cube_face_diagonal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cube_space_diagonal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_prism_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_prism_surface": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_prism_diagonal": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_pyramid_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_pyramid_surface": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cylinder_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cylinder_surface": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cone_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cone_slant": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cone_surface": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_sphere_volume": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_sphere_surface": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_frustum": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_revolution": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_set_members": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_experimental_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_experimental_prediction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_sample_space": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_likelihood": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_single_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_probability_prediction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_complement": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_venn_regions": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_geometric_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_union_sets": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_intersection_sets": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_compound_trials": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_venn_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_venn_complements": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_three_events": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_addition_law": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_addition_complements": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_exclusive_events": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_conditional_venn": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_conditional_table": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_conditional_product": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_total_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_dependent_tree": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_dependent_application": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_independence": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_independent_tree": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_counting_rules": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_factorial": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_factorial_ratio": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_arrangements": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_permutations": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_combinations": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_combinatorial_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_copy_segment": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_copy_angle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_bisect_segment": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_bisect_angle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_perpendicular_bisector": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_parallel_construction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_equilateral_construction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_square_construction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_hexagon_construction": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_incircle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_circumcircle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_external_tangent": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_parabola": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_ellipse": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_hyperbola": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_sine_area": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_law_sines": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_law_cosines": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_density": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_design": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cross_sections": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_cavalieri": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_scale_rigid": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "geo_precise_definitions": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "c1_motion": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_inverse_deriv": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_inverse_trig_deriv": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_limit_estimate": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_volume_shell": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_slope_field": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_polar_slope": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_parametric_arc": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_division_remainder": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_phase_shift": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_inverse_trig": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_1_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_1_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_1_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_1_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_1_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_1_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_1_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_series_1_2_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_2_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_2_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_2_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_2_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_2_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_series_1_2_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_series_1_3_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_3_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_3_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_series_1_3_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_4_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_4_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_4_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_4_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_4_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_5_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_5_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_5_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_5_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_5_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_5_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_5_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_5_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_5_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_5_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_rational_2_5_11": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_6_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_6_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_6_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_6_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_6_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_6_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_6_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_7_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_7_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_7_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_7_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_8_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_8_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_8_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_8_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_8_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_8_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_8_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_8_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_8_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_inequalities_3_8_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_9_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_9_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_9_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_9_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_9_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_10_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_10_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_10_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_10_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_10_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_10_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_10_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_11_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_11_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_11_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_11_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_11_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_11_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_11_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_12_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_12_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_12_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_12_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_12_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_12_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_12_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_12_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_13_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_13_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_13_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_13_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_13_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_13_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_13_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_14_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_14_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_14_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_14_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_15_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_15_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_15_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_trigonometry_4_15_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_16_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_16_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_16_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_16_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_16_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_16_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_16_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_16_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_17_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_17_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_17_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_17_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_17_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_17_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_vectors_5_17_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_vectors_5_18_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_18_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_18_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_19_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_19_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_19_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_19_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_19_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_20_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_20_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_20_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_20_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_vectors_5_20_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_vectors_5_20_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_vectors_5_20_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_matrices_6_21_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_21_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_21_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_21_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_21_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_21_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_21_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_22_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_22_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_22_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_22_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_22_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_22_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_22_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_22_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_22_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_23_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_23_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_23_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_23_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_24_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_24_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_24_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_24_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_24_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_25_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_25_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_25_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_25_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_25_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_25_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_25_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_25_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_25_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_25_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_matrices_6_25_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_matrices_6_25_12": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_26_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_26_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_26_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_26_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_26_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_26_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_26_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_26_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_26_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_26_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_conics_7_27_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_27_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_27_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_27_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_27_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_27_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_27_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_27_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_27_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_7_27_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_parametric_8_28_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_parametric_8_28_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_parametric_8_28_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_parametric_8_28_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_parametric_8_28_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_parametric_8_28_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_parametric_8_28_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_parametric_8_28_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_parametric_8_28_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_parametric_8_28_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_polar_9_29_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_polar_9_29_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_polar_9_29_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_polar_9_29_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_polar_9_29_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_polar_9_29_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_30_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_30_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_30_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_30_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_30_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_31_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_31_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_31_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_31_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_31_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_31_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_32_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_32_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_32_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_32_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_33_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_33_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_33_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_33_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_33_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_33_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_33_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_33_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_34_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_34_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_34_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_34_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_complex_10_34_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_probability_11_35_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_35_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_35_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_35_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_35_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_35_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_35_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_35_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_35_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_35_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_36_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_36_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_36_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_36_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_36_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_36_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_36_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_36_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_36_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_37_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_37_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_37_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_37_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_37_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_37_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_37_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_37_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_38_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_38_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_38_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_38_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_38_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_38_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_38_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_39_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_39_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_39_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_39_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_39_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_39_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_39_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_40_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_40_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_40_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_40_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_40_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_40_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_probability_11_40_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_41_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_41_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_41_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_41_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_41_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_41_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_41_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_42_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_42_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_42_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_42_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_42_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_42_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_42_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_42_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_43_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_43_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_43_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_43_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_statistics_12_43_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "pc_conics_ellipse_focus_derivation": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "pc_conics_hyperbola_focus_derivation": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_interval_convergence": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_lagrange_error": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_trig_sub": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c1_squeeze": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_partial_repeated": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_maclaurin_manip": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_vector_motion": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_normal_table": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_series_termwise": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_partial_quadratic": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_volume_axis": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "a2_simulation": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "c2_shell_axis": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im1_1_1_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_1_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_1_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_1_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_2_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_2_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_2_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_2_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_2_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_2_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_2_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_3_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_3_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_3_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_3_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_3_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_3_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_3_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_3_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_3_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_3_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_3_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_4_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_4_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_1_4_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_5_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_5_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_5_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_5_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_5_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_6_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_6_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_6_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_6_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_6_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_6_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_6_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_7_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_7_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_7_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_7_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_7_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_7_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_7_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_2_8_13": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_9_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_9_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_9_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_9_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_9_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_9_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_9_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_9_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_9_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_9_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_10_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_10_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_3_10_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_11_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_11_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_11_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_11_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_12_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_12_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_12_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_12_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_13_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_13_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_13_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_13_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_13_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_13_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_13_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_13_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_4_13_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_13": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_5_14_14": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_15_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_15_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_15_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_15_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_15_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_15_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_16_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_16_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_16_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_16_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_16_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_16_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_16_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_6_16_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_17_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_17_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_17_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_17_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_17_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_17_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_13": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_14": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_7_18_15": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_19_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_19_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_19_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_19_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_19_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_19_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_19_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_19_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_19_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_19_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_19_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_20_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_20_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_20_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_20_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_20_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_20_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_20_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_20_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_8_20_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_21_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_21_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_21_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_21_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_21_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_21_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_21_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_21_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_21_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_21_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_21_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_21_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_22_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_22_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_22_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_22_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_22_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_22_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_22_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_22_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_22_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_23_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_23_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_23_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_23_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_23_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_23_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_23_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_23_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_23_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_23_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_23_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_24_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_24_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_24_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_24_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_24_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_24_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_24_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_24_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_24_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_24_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_9_24_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_arithmetic_sequence": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_geometric_sequence": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_rational_irrational": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_number_line": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_data_plots": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_data_center": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_data_spread": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_outliers": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_two_way": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_scatter": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_fit_line": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_residual": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_correlation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_1_1_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_11": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_12": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_13": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_14": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_15": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_16": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_17": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_18": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_19": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_1_20": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_2_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_2_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_2_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_2_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_2_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_2_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_2_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_2_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_2_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_2_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_2_11": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_2_12": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_3_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_3_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_3_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_3_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_3_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_1_3_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_2_4_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_2_4_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_11": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_12": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_13": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_14": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_15": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_4_16": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_11": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_12": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_5_13": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_6_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_2_6_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_2_6_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_7_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_7_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_7_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_7_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_7_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_7_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_8_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_8_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_8_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_8_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_8_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_8_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_9_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_9_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_9_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_9_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_3_9_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_4_10_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_10_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_10_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_10_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_10_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_10_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_10_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_10_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_10_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_11_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_11_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_11_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_11_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_11_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_11_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_11_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_11_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_11_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_12_13": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_13_13": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_14_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_14_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_14_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_14_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_14_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_14_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_14_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_14_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_15_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_15_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_15_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_15_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_15_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_15_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_15_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_15_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_15_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_16_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_16_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_16_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_16_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_16_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_16_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_16_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_16_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_4_16_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_17_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_17_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_17_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_17_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_17_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_17_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_17_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_17_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_17_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_17_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_17_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_17_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_18_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_18_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_18_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_18_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_5_19_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_19_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_19_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_19_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_19_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_19_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_19_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_19_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_19_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_19_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_19_11": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_20_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_20_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_20_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_20_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_5_20_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im2_6_21_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_21_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_21_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_21_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_21_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_21_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_21_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_21_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_21_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_21_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_22_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_22_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_22_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_22_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_22_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_22_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_23_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_23_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_23_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_23_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_23_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_23_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_23_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_6_23_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_rational_exponents": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_repeating_decimals": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_irrational_sum": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_irrational_product": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_imaginary_unit": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_complex_add": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_complex_multiply": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_complex_quadratic": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_polynomial_identity": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_compare_models": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_piecewise": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_model_constraints": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_rewrite_formula": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_dilation_rays": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_dilation_segments": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_circle_equation": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_circle_complete": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_parabola_focus": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_cross_sections": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_cavalieri": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_conditional_venn": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_conditional_table": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_independence": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_conditional_product": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_total_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_counting_rules": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_permutations": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_combinations": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_decision_probability": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_coordinate_partition": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_parallelogram_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_incircle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_circumcircle": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_external_tangent": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_quadratic_inequalities": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_fair_decisions": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_isosceles_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_centroid_proof": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_rectangle_criteria": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_chord_bisector": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "la_vec_combo": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_vec_length": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_unit_vector": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_dot": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_angle": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_orthogonal": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_projection": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_cross": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_cross_area": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_aug_matrix": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_row_ops": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_echelon": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_solve_system": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_solution_count": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_free_variable": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_rank": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_mat_add": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_mat_size": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_mat_vec": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_mat_entry": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_mat_mult": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_transpose": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_mat_power": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_commute": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_det2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_det3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_det_triangular": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_det_props": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_inverse2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_inverse3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_inverse_solve": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_cramer": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_area_det": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_lin_comb": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_span": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_independent": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_dependence_k": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_nullity": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_null_basis": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_coords": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_lt_matrix": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_lt_geometry": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_lt_compose": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_lt_area": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_lt_linear": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_eig_check": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_char_poly": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_eigenvalues": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_eigenvector": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_trace_det": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_diagonalize": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_complex_eig": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_gram_schmidt": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_proj_plane": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_least_squares": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "la_orth_matrix": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_1_1_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_1_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_1_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_1_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_1_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_2_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_2_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_2_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_2_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_3_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_3_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_3_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_3_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_4_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_4_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_4_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_4_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_4_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_4_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_4_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_4_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_5_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_5_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_5_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_5_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_5_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_5_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_6_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_6_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_1_6_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_7_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_7_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_7_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_7_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_7_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_8_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_8_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_8_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_8_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_8_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_8_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_9_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_9_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_9_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_9_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_10_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_10_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_10_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_10_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_10_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_10_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_10_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_10_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_10_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_2_10_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_11_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_11_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_11_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_11_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_11_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_12_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_12_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_12_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_12_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_12_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_12_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_13_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_13_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_13_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_13_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_14_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_14_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_3_14_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_4_15_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_4_15_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_4_15_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_4_16_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_4_16_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_4_16_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_4_16_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_4_16_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_4_16_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_4_16_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_17_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_17_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_17_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_17_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_17_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_17_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_17_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_17_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_17_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_18_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_18_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_18_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_18_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_18_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_5_18_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_19_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_19_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_19_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_19_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_19_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_20_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_20_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_20_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_20_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_20_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_20_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_20_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_20_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_20_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_20_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_20_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_21_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_21_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_21_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_21_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_21_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_21_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_21_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_21_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_6_21_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_22_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_22_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_22_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_22_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_22_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_23_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_23_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_23_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_23_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_23_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_23_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_23_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_23_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_23_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_23_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_24_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_24_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_24_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_24_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_24_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_24_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_24_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_24_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_24_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_24_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_25_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_25_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_25_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_25_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_25_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_7_25_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_26_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_26_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_26_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_26_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_26_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_26_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_26_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_26_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_26_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_26_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_26_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_27_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_27_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_27_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_27_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_27_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_27_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_27_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_28_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_28_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_28_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_8_28_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_1_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_1_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_1_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_1_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_2_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_2_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_2_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_2_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_2_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_2_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_2_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_3_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_3_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_3_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_3_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_3_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_3_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_3_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_3_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_3_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_3_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_3_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_4_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_4_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_1_4_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_5_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_5_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_5_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_5_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_5_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_6_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_6_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_6_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_6_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_6_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_6_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_6_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_7_13": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_8_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_8_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_8_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_8_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_8_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_8_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_2_8_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_9_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_9_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_9_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_9_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_9_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_9_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_9_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_9_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_9_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_9_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_10_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_10_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_3_10_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_11_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_11_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_11_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_11_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_11_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_11_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_11_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_11_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_11_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_12_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_12_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_12_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_12_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_13_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_13_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_13_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_4_13_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_13": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_5_14_14": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_6_15_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_6_15_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_6_15_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_6_15_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_6_15_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_6_15_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_16_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_16_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_16_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_16_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_16_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_16_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_17_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_17_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_17_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_17_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_18_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_18_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_18_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_18_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_18_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_18_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_18_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_18_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_18_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_18_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_7_18_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_19_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_19_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_19_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_19_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_19_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_19_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_19_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_19_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_19_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_19_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_19_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_20_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_20_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_20_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_20_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_20_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_20_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_20_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_20_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_8_20_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_9_21_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im1_h_9_21_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_9_21_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im1_h_9_22_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_9_22_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_9_22_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_9_22_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_9_22_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_9_22_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_9_22_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_9_22_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_9_22_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_23_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_23_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_23_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_23_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_23_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_23_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_23_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_23_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_24_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_24_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_24_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_24_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_24_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_24_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_24_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_24_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_24_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_24_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_24_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_24_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_25_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_25_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_25_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_25_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_25_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_25_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_25_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_25_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_25_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_26_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_26_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_26_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_26_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_26_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_26_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_26_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_26_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_26_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_27_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_27_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_27_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_27_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_27_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_27_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_27_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_27_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_27_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_27_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_27_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_28_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_28_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_28_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_28_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_28_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_28_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_28_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_28_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_28_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_28_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_10_28_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_11_29_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_11_29_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_11_29_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_11_29_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_11_29_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_11_29_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_geometric_sequence": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_rational_irrational": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_number_line": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_data_plots": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_data_center": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_data_spread": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_outliers": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_two_way": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im1_h_residual": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_1_1_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_1_1_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_1_1_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_1_2_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_1_2_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_1_2_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_1_2_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_1_2_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_1_2_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_1_2_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_3_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_3_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_14": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_15": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_16": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_17": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_4_18": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_5_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_5_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_5_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_5_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_5_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_6_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_6_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_6_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_2_6_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_7_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_7_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_7_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_7_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_7_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_7_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_7_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_7_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_7_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_7_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_8_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_8_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_8_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_3_8_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_13": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_14": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_16": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_9_17": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_10_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_10_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_10_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_10_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_10_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_10_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_10_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_10_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_4_10_13": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_5_11_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_5_11_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_5_11_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_5_11_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_5_11_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_5_11_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_5_11_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_12_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_12_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_12_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_12_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_13_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_13_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_13_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_13_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_13_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_14_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_14_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_14_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_14_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_14_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_15_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_15_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_15_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_15_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_16_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_16_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_16_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_16_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_16_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_17_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_17_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_17_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_17_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_17_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_17_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_18_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_18_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_6_18_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_19_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_19_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_19_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_19_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_19_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_20_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_20_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_20_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_20_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_20_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_20_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_21_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_21_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_21_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_7_21_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_8_22_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_8_22_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_8_22_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_8_22_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_8_22_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_8_23_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_8_23_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_24_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_24_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_24_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_24_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_24_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_24_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_24_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_24_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_24_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_24_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_24_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_24_13": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_25_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_25_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_25_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_25_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_25_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_25_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_25_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_25_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_25_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_25_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_26_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_26_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_26_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_26_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_26_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_26_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_26_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_27_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_27_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_27_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_27_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_27_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_27_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_27_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_27_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_27_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_28_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_28_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_28_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_28_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_28_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_28_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_28_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_9_28_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_29_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_29_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_29_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_29_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_29_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_29_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_29_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_29_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_30_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_30_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_30_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_30_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_30_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_30_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_31_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_31_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_31_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_31_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_31_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_31_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_10_31_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_32_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_32_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_32_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_32_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_32_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_32_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_32_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_32_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_32_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_32_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_32_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_32_12": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_33_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_33_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_33_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_33_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_34_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_34_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_34_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_34_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_34_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_34_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_34_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_34_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_34_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_34_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_34_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_35_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_35_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_35_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_35_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_35_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_36_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_36_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_36_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_37_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_37_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_37_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_38_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_38_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_38_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_38_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_38_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_38_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_38_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_38_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_38_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_38_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_39_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_39_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_39_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_39_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_39_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_11_39_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_40_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_40_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_40_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_40_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_40_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_40_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_40_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_40_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_40_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_40_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_41_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_41_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_41_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_41_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_41_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_41_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_42_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_42_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_42_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_42_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_42_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_42_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_42_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_42_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_42_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_42_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_42_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_43_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_43_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_43_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_43_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_43_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_43_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_43_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_44_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_44_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_44_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_44_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_44_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_44_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_45_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_45_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im2_h_12_45_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_1_1_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_1_1_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_1_1_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_1_1_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_1_1_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_1_1_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_1_1_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_2_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_2_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_2_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_2_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_2_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_2_3_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_3_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_3_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_3_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_3_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_3_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_3_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_3_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_4_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_4_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_4_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_4_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_4_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_2_4_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_3_5_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_5_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_5_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_6_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_3_6_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_3_6_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_3_6_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_3_6_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_3_6_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_3_7_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_7_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_7_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_7_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_7_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_7_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_7_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_7_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_7_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_7_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_7_11": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_3_7_12": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_4_8_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_4_8_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_4_8_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_4_8_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_4_9_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_4_9_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_4_9_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_4_9_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_4_9_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_4_9_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_4_9_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_4_9_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_4_9_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_5_10_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_10_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_10_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_10_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_10_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_10_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_10_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_11_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_11_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_11_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_11_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_12_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_12_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_12_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_12_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_12_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_12_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_12_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_12_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_12_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_5_12_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_13_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_13_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_13_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_13_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_13_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_13_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_13_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_13_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_13_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_13_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_6_14_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_14_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_14_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_14_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_14_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_14_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_14_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_14_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_14_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_6_14_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_7_15_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_7_15_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_7_15_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_7_15_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_7_15_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_7_16_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_7_16_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_7_16_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_7_16_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_7_16_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_17_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_17_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_17_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_17_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_17_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_17_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_17_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_18_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_18_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_18_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_18_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_18_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_18_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_18_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_19_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_19_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_19_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_19_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_19_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_19_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_19_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_8_19_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_20_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_20_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_20_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_20_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_20_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_20_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_20_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_21_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_21_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_21_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_21_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_22_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_22_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_22_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_9_22_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_10_23_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_10_23_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_10_23_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_10_23_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_10_23_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_10_23_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_10_23_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_10_23_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_10_23_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_10_23_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_11_24_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_11_24_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_11_24_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_11_24_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_11_24_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_11_24_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_25_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_25_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_25_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_25_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_25_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_26_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_26_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_26_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_26_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_26_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_26_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_27_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_27_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_27_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_27_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_28_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_28_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_28_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_28_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_28_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_28_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_28_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_28_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_29_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_29_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_29_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_29_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_12_29_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_30_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_30_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_30_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_30_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_30_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_30_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_30_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_30_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_31_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_31_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_31_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_31_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_31_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_31_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_13_31_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_13_32_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_32_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_32_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_33_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_33_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_33_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_33_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_33_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_34_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_34_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_34_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_34_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_13_34_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_13_34_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_13_34_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_14_35_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_35_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_35_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_35_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_35_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_35_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_35_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_36_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_36_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_36_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_36_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_36_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_36_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_36_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_36_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_36_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_37_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_37_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_37_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_37_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_38_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_38_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_38_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_38_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_38_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_39_1": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_39_2": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_39_3": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_39_4": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_39_5": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_39_6": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_39_7": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_39_8": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_39_9": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_39_10": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_14_39_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_14_39_12": {
    "roles": [],
    "slots": {},
    "policy": "bare"
  },
  "im3_h_15_40_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_40_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_40_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_40_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_41_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_41_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_41_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_41_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_41_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_41_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_41_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_42_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_42_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_42_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_42_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_42_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_42_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_42_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "im3_h_15_42_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_1_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_1_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_1_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_2_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_2_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_2_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_3_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_3_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_3_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_4_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_4_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_4_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_4_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_5_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_5_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_6_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_6_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_7_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_7_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_1_7_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_2_8_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_2_8_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_2_8_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_2_8_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_2_8_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_2_9_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_2_9_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_3_10_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_3_10_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_3_10_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_3_10_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_3_11_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_3_11_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_3_12_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_3_12_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_3_12_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_3_12_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_4_13_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_4_13_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_4_13_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_4_13_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_4_14_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_4_15_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_4_15_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_5_16_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_5_16_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_5_17_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_5_17_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_5_17_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_5_18_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_5_18_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_5_18_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_5_19_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_5_19_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_6_20_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_6_20_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_6_21_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_6_21_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_6_21_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_6_22_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_6_22_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_6_23_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_7_24_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_7_24_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_7_25_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_7_25_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_7_25_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_7_25_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_8_26_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_8_26_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_8_26_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_8_27_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_8_27_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_8_28_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_8_28_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_8_29_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_8_29_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_8_29_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_8_29_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_9_30_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_9_30_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_9_30_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_9_30_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_9_31_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_9_31_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_9_32_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_10_33_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_10_33_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_10_33_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_10_33_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_10_34_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_10_34_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_10_34_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_10_35_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_10_35_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_11_36_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_11_36_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_11_36_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_11_36_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_11_36_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_11_36_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_11_37_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_11_37_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_11_38_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_11_38_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_12_39_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_12_39_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_12_40_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_12_40_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_41_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_41_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_41_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_42_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_42_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_42_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_42_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_43_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_43_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_43_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_43_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_43_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_43_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_43_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_44_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_44_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_44_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_45_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_45_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_46_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_46_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_47_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_47_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_48_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_48_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_49_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_13_49_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_14_50_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_14_50_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_14_50_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_14_50_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_14_51_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_14_51_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_14_51_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_14_52_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_14_52_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_15_53_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_15_53_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_15_53_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_15_54_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_15_54_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_15_54_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_15_55_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_15_55_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_15_55_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_56_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_56_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_57_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_57_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_58_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_59_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_59_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_59_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_59_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_59_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_60_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_60_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_60_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_16_60_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_61_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_61_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_62_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_62_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_62_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_63_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_63_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_64_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_64_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_64_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_65_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_65_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_65_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_66_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_66_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_66_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_67_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_67_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_67_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_68_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_68_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_17_68_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "satf_coordinate_practice": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_1_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_1_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_1_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_1_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_1_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_1_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_1_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_1_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_1_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_1_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_1_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_2_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_2_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_2_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_2_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_2_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_2_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_3_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_3_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_3_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_3_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_3_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_4_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_4_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_4_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_4_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_5_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_5_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_5_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_5_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_5_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_6_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_6_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_6_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_6_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_6_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_6_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_6_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_6_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_6_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_7_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_7_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_7_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_8_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_8_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_8_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_8_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_8_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_8_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_9_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_9_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_9_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_9_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_9_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_9_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_9_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_9_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_9_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_10_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_10_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_10_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_10_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_10_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_10_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_10_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_11_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_11_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_11_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_11_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_11_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_11_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_12_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_12_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_12_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_12_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_12_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_1_12_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_13_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_13_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_13_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_13_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_13_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_13_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_13_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_14_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_14_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_14_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_14_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_14_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_15_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_15_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_15_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_16_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_16_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_16_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_16_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_16_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_16_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_16_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_16_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_16_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_16_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_16_11": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_17_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_17_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_17_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_17_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_17_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_17_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_17_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_17_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_17_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_18_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_18_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_18_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_18_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_18_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_18_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_19_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_19_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_19_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_19_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_19_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_19_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_20_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_20_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_20_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_20_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_20_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_20_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_20_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_21_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_21_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_21_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_21_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_21_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_21_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_22_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_22_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_22_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_22_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_22_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_22_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_23_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_23_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_23_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_23_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_24_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_24_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_24_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_25_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_25_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_25_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_25_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_25_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_25_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_2_25_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_26_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_26_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_26_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_26_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_26_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_26_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_26_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_26_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_26_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_27_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_27_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_27_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_27_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_28_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_28_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_28_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_28_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_28_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_28_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_28_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_29_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_29_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_29_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_29_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_29_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_29_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_30_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_30_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_30_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_30_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_31_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_31_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_31_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_31_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_32_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_32_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_32_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_32_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_32_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_32_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_32_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_32_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_32_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_32_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_33_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_33_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_33_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_33_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_33_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_33_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_33_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_33_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_33_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_34_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_34_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_34_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_34_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_34_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_34_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_3_34_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_35_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_35_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_35_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_35_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_35_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_36_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_36_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_36_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_36_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_36_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_37_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_37_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_37_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_37_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_37_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_37_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_38_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_38_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_38_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_38_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_38_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_38_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_39_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_39_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_39_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_39_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_39_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_39_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_40_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_40_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_40_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_40_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_40_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_40_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_41_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_41_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_41_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_41_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_41_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_42_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_42_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_42_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_42_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_42_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_43_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_43_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_43_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_43_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_43_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_43_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_43_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_44_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_44_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_44_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_44_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_44_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_44_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_45_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_45_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_45_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_45_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_45_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_45_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_45_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_45_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_45_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "sat_4_45_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_1_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_1_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_1_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_1_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_2_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_2_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_2_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_3_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_3_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_3_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_3_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_3_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_3_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_3_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_3_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_4_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_4_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_4_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_4_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_1_4_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_5_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_5_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_5_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_5_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_5_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_5_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_5_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_5_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_5_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_6_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_6_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_6_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_6_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_6_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_6_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_2_6_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_7_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_7_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_7_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_8_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_8_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_9_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_9_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_9_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_9_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_10_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_10_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_10_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_10_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_10_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_11_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_11_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_11_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_12_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_12_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_3_12_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_13_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_13_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_13_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_13_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_13_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_13_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_13_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_13_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_13_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_13_10": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_14_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_14_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_14_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_15_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_15_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_15_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_16_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_16_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_16_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_16_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_4_16_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_17_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_17_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_17_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_17_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_17_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_17_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_17_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_18_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_18_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_18_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_18_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_18_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_18_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_18_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_19_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_19_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_19_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_19_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_19_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_20_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_20_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_20_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_20_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_20_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_20_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_20_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_21_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_21_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_21_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_21_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_5_21_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_22_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_22_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_22_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_22_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_22_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_22_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_22_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_22_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_22_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_23_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_23_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_23_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_23_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_23_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_24_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_24_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_24_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_24_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_24_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_24_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_6_24_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_25_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_25_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_25_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_25_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_25_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_25_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_26_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_26_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_26_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_26_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_26_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_26_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_27_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_27_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_7_27_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_28_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_28_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_28_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_28_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_28_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_28_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_28_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_28_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_28_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_29_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_29_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_29_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_29_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_29_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_29_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_29_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_30_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_30_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_8_30_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_9_31_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_9_31_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_9_31_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_9_31_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_9_31_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_9_31_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_9_32_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_9_32_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_9_32_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_9_32_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_9_32_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_10_33_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_10_33_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_10_33_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_10_33_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_10_33_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_10_33_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "ps_10_33_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_1_1_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_1_1_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_1_1_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_1_1_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_2_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_2_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_2_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_2_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_2_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_2_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_2_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_2_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_3_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_3_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_3_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_3_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_3_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_3_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_4_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_4_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_2_4_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_5_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_5_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_5_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_5_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_5_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_5_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_5_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_5_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_6_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_6_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_6_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_7_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_7_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_7_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_3_7_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_8_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_8_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_8_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_8_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_8_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_8_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_8_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_8_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_8_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_9_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_9_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_9_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_10_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_10_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_11_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_11_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_11_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_12_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_12_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_12_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_12_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_13_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_13_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_13_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_14_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_14_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_15_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_15_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_16_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_16_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_16_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_16_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_17_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_17_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_17_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_17_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_17_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_17_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_4_17_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_18_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_18_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_18_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_19_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_19_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_19_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_19_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_19_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_20_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_20_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_20_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_20_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_20_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_5_20_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_21_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_21_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_21_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_21_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_22_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_22_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_22_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_22_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_22_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_23_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_23_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_23_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_23_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_6_23_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_24_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_24_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_24_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_24_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_24_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_24_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_24_7": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_24_8": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_24_9": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_25_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_25_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_25_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_26_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_26_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_27_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_27_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_27_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_27_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_28_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_28_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_28_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_29_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_29_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_29_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_29_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_29_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_7_29_6": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_30_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_30_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_31_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_31_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_31_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_31_4": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_31_5": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_32_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_32_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_32_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_33_1": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_33_2": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_8_33_3": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  },
  "dm_dfs": {
    "roles": [],
    "slots": {},
    "policy": "fixed"
  }
}
